export const MAX_ADDITIONAL_IMAGES = 5;

export function validateTeamInterestForm(data, config) {
  const errors = [];

  if (!data.contactName) errors.push('Contact Name is required.');
  if (!data.contactEmail) errors.push('Contact Email is required.');
  if (data.contactEmail && !data.contactEmail.includes('@')) errors.push('Contact Email must be a valid email.');
  if (!data.teamName) errors.push('Team Name is required.');
  if (!data.logoFile) errors.push('Team Logo is required.');
  if (data.additionalFiles.length > MAX_ADDITIONAL_IMAGES) errors.push(`Maximum ${MAX_ADDITIONAL_IMAGES} Additional Images allowed.`);

  if (!config.variantId) {
    errors.push('Team Deposit product is not configured. Please contact support.');
  }

  return errors;
}

export class TeamInterestForm {
  constructor() {
    this.config = this.#loadConfig();
    this.form = document.getElementById('team-interest-form');
    this.errorsContainer = document.getElementById('team-interest-errors');
    this.submitButton = document.getElementById('team-interest-submit');
    this.submitButtonText = this.submitButton.textContent.trim();

    this.form.addEventListener('submit', (event) => this.#handleSubmit(event));

    document.getElementById('team-logo').addEventListener('change', (event) => {
      this.#renderPreview(event.target.files, 'team-logo-preview');
    });
    document.getElementById('team-additional-images').addEventListener('change', (event) => {
      this.#renderPreview(event.target.files, 'team-additional-preview');
    });
  }

  #loadConfig() {
    const element = document.getElementById('team-interest-config');
    if (!element) return {};

    try {
      return JSON.parse(element.textContent);
    } catch {
      return {};
    }
  }

  #renderPreview(files, previewId) {
    const container = document.getElementById(previewId);
    container.querySelectorAll('img').forEach((img) => URL.revokeObjectURL(img.src));

    if (!files || files.length === 0) {
      container.hidden = true;
      container.innerHTML = '';
      return;
    }

    container.innerHTML = '';
    for (const file of files) {
      const img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = file.name;
      container.appendChild(img);
    }
    container.hidden = false;
  }

  #readFormData() {
    return {
      additionalFiles: document.getElementById('team-additional-images').files,
      contactEmail: document.getElementById('team-contact-email').value.trim(),
      contactName: document.getElementById('team-contact-name').value.trim(),
      logoFile: document.getElementById('team-logo').files[0] || null,
      teamName: document.getElementById('team-name').value.trim(),
    };
  }

  #validate(data) {
    return validateTeamInterestForm(data, this.config);
  }

  #showErrors(messages) {
    this.errorsContainer.innerHTML = `<ul>${messages.map((msg) => `<li>${this.#escapeHtml(msg)}</li>`).join('')}</ul>`;
    this.errorsContainer.hidden = false;
    this.errorsContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  async #handleSubmit(event) {
    event.preventDefault();

    const data = this.#readFormData();
    const errors = this.#validate(data);
    if (errors.length > 0) {
      this.#showErrors(errors);
      return;
    }

    this.errorsContainer.hidden = true;
    this.submitButton.disabled = true;
    this.submitButton.textContent = 'Uploading...';

    try {
      const formData = new FormData();
      formData.append('id', this.config.variantId);
      formData.append('quantity', 1);
      formData.append('properties[Contact Name]', data.contactName);
      formData.append('properties[Team Name]', data.teamName);
      formData.append('properties[_contact_email]', data.contactEmail);
      formData.append('properties[_logo]', data.logoFile);

      for (let i = 0; i < data.additionalFiles.length; i++) {
        formData.append(`properties[_additional_image_${i + 1}]`, data.additionalFiles[i]);
      }

      const response = await fetch('/cart/add.js', {
        body: formData,
        method: 'POST',
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.description || 'Failed to add deposit to cart');
      }

      window.location.href = '/cart';
    } catch (error) {
      this.#showErrors([`Something went wrong: ${error.message}`]);
      this.submitButton.disabled = false;
      this.submitButton.textContent = this.submitButtonText;
    }
  }

  #escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('team-interest-form')) {
    new TeamInterestForm();
  }
});
